import React from 'react';
import Banner from '../layout/Banner';
import Footer from '../layout/Footer'; 
import './GeneralTemplate.less'

function GeneralTemplate({ bannerProps, content }) {
  return (
    <div className="main-container">
      <Banner 
       imageSrc={bannerProps.imageSrc}
       height={bannerProps.height}
       titeSize={bannerProps.titeSize}
       title={bannerProps.title}
       subtitle={bannerProps.subtitle}
      />
      <div className="content">
        {content}
      </div>
      <Footer/>
    </div>
  );
}

export default GeneralTemplate;